import React, { useCallback } from 'react';
import { Accordion as Accordion$1, AccordionItem, AccordionButton, Box, AccordionPanel, AccordionIcon } from '@chakra-ui/react';
import { AccordionIconPositionType } from './types.js';
import { Typography } from '../Typography/component.js';
import { Icon } from '../Icon/component.js';
var Accordion = function Accordion(_ref) {
  var _ref$allowMultiple = _ref.allowMultiple,
    allowMultiple = _ref$allowMultiple === void 0 ? true : _ref$allowMultiple,
    _ref$index = _ref.index,
    index = _ref$index === void 0 ? undefined : _ref$index,
    _ref$defaultIndex = _ref.defaultIndex,
    defaultIndex = _ref$defaultIndex === void 0 ? undefined : _ref$defaultIndex,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$stepper = _ref.stepper,
    stepper = _ref$stepper === void 0 ? false : _ref$stepper,
    _ref$headingLevel = _ref.headingLevel,
    headingLevel = _ref$headingLevel === void 0 ? 'h2' : _ref$headingLevel,
    _ref$hideVisitedStatu = _ref.hideVisitedStatus,
    hideVisitedStatus = _ref$hideVisitedStatu === void 0 ? false : _ref$hideVisitedStatu,
    _ref$accordionIconPos = _ref.accordionIconPosition,
    accordionIconPosition = _ref$accordionIconPos === void 0 ? AccordionIconPositionType.LEFT : _ref$accordionIconPos,
    _ref$allowToggle = _ref.allowToggle,
    allowToggle = _ref$allowToggle === void 0 ? true : _ref$allowToggle,
    _ref$visitedIcon = _ref.visitedIcon,
    visitedIcon = _ref$visitedIcon === void 0 ? {
      prefix: 'fas',
      iconName: 'check-circle'
    } : _ref$visitedIcon;
  /**
   * Methods
   */
  var onVisit = function onVisit(item) {
    item.visited = !hideVisitedStatus;
  };
  /**
   * DOM
   */
  return /*#__PURE__*/React.createElement(Accordion$1, {
    "data-object-type": "accordion",
    allowMultiple: allowMultiple,
    index: index,
    defaultIndex: defaultIndex || (allowMultiple ? [0] : undefined)
    /**
     * Chakra says one or other prop
     * If 'allowMultiple' is passed, 'allowToggle' will be ignored. Either remove 'allowToggle' or 'allowMultiple' depending on whether you want multiple accordions visible or not
     */,
    allowToggle: allowMultiple ? undefined : allowToggle
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(AccordionItem, {
      key: "accordion-item-".concat(index)
    }, function (_ref2) {
      var isExpanded = _ref2.isExpanded;
      /**
       * Methods
       */
      var handleOnClick = useCallback(function () {
        onVisit(item);
        if (!isExpanded) {
          var _item$onExpand;
          (_item$onExpand = item.onExpand) === null || _item$onExpand === void 0 || _item$onExpand.call(item);
        } else {
          var _item$onCollapse;
          (_item$onCollapse = item.onCollapse) === null || _item$onCollapse === void 0 || _item$onCollapse.call(item);
        }
      }, [isExpanded]);

      /**
       * DOM
       */
      var showTick = !!item.visited || !hideVisitedStatus && isExpanded;
      if (stepper) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
          variant: headingLevel
        }, /*#__PURE__*/React.createElement(AccordionButton, {
          onClick: handleOnClick,
          "data-action-target": "accordion"
        }, showTick && /*#__PURE__*/React.createElement(Icon, visitedIcon), !showTick && (item.stepperIcon && (item.stepperIcon.iconName || item.stepperIcon.icon) ? /*#__PURE__*/React.createElement(Icon, item.stepperIcon) : /*#__PURE__*/React.createElement(React.Fragment, null, " ", index + 1)), /*#__PURE__*/React.createElement(Box, {
          as: "span",
          flex: "1",
          textAlign: "left",
          pl: 2
        }, item.title))), /*#__PURE__*/React.createElement(AccordionPanel, {
          pb: 4,
          pl: 10
        }, item.body));
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
        variant: headingLevel
      }, /*#__PURE__*/React.createElement(AccordionButton, {
        onClick: handleOnClick,
        "data-action-target": "accordion"
      }, accordionIconPosition === AccordionIconPositionType.LEFT && /*#__PURE__*/React.createElement(AccordionIcon, null), /*#__PURE__*/React.createElement(Box, {
        as: "span",
        flex: "1",
        textAlign: "left",
        pl: 2
      }, item.title), showTick && /*#__PURE__*/React.createElement(Icon, visitedIcon), accordionIconPosition === AccordionIconPositionType.RIGHT && /*#__PURE__*/React.createElement(AccordionIcon, null))), /*#__PURE__*/React.createElement(AccordionPanel, {
        pb: 4,
        pl: 10
      }, item.body));
    });
  }));
};
Accordion.displayName = "Accordion";
export { Accordion };